import { ThemeModule } from '../../front/lib/ThemeModule';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
export class Map extends ThemeModule {
    init() {
        this.initMap();
    }
    async initMap() {
        let map;
        await google.maps.importLibrary("marker");
        map = new google.maps.Map(this.getElementById('map'), {
            mapId: '1242ee163a7a671e',
            zoom: 2,
            minZoom: 2,
            center: { lat: 20.905675, lng: 60.443895 },
        });
        let markers = this.json.dealers.map(dealer => {
            let marker = new google.maps.marker.AdvancedMarkerElement({
                position: {
                    lat: dealer.lat,
                    lng: dealer.lng,
                },
                content: new google.maps.marker.PinElement({
                    background: dealer.color || '#00af49',
                    borderColor: dealer.color || '#00af49',
                    glyphColor: '#fff',
                    scale: 1.25,
                }).element,
            });
            let content = [];
            if (dealer.department) {
                content.push(`<p class="dealer-department">${dealer.department}</p>`);
            }
            content.push('<hr>');
            if (dealer.address) {
                content.push(`<div class="dealer-address">${dealer.address}</div>`);
            }
            if (dealer.phone) {
                content.push(`<p><a class="dealer-link" href="tel:${dealer.phone}">${dealer.phone}</a></p>`);
            }
            if (dealer.email) {
                content.push(` <p><a class="dealer-link" href="mailto:${dealer.email}">${dealer.email}</a></p>`);
            }
            let infoWindow = new google.maps.InfoWindow({
                content: `<div class="dealer on--map ${dealer.color}">
                    <p class="dealer-country">${dealer.country}</p>
                    <p class="dealer-title">${dealer.title}</p>
                    ${content.join('')}
                </div>`
            });
            marker.addListener('click', () => {
                infoWindow.open(map, marker);
            });
            return marker;
        });
        new MarkerClusterer({
            map,
            markers,
            algorithmOptions: {
                maxZoom: 15,
            },
            renderer: {
                render: ({ count, position, markers }, stats, map) => {
                    // change color if this cluster has more markers than the mean cluster
                    const color = '#000000';
                    // create svg literal with fill color
                    const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
                    <circle cx="120" cy="120" opacity=".6" r="70" />
                    <circle cx="120" cy="120" opacity=".3" r="90" />
                    <circle cx="120" cy="120" opacity=".2" r="110" />
                    <text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="75" font-weight="700" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
                    </svg>`;
                    const title = `Cluster of ${count} markers`, 
                    // adjust zIndex to be above other markers
                    zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
                    // create cluster SVG element
                    const parser = new DOMParser();
                    const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
                    svgEl.setAttribute("transform", "translate(0 25)");
                    const clusterOptions = {
                        map,
                        position,
                        zIndex,
                        title,
                        content: svgEl
                    };
                    return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
                }
            },
        });
    }
}
